import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import useAPIResReqStore from '../useAPIResReqStore';

const ConfigurationModeSelector = ({ onModeChange, hideManualOption = false }) => {
  return (
    <Grid container className="setup-mode-container">
      <Grid item className="width-100">
        <FormControl className="form-control-full">
          <Grid item xs={12} className="setup-mode-label">
            Configuration mode
          </Grid>
          <RadioGroup
            name="setupMode"
            value={useAPIResReqStore.getState().requestData.setupMode}
            onChange={event => onModeChange(event.target.value)}
          >
            {!hideManualOption && (
              <FormControlLabel
                value="MANUAL"
                control={<Radio />}
                label="Manually set each field"
              />
            )}
            <FormControlLabel value="CURL" control={<Radio />} label="Write cURL" />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ConfigurationModeSelector;
